import { prop } from "ramda";
import { Div, MainText } from "@base-ui";
import { TargetContainer, TargetValue, TextContainer } from "./metaInformation.styles";
import { cleanHtml } from "utils/cleanHtml";
import { sort } from "utils/sort";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ContentInformation(_ref) {
  var _metadata$information;
  var metadata = _ref.metadata;
  if (!metadata) return null;
  var valueExtension = metadata.measureUnit === "%" && "%";
  var header = function header(title) {
    return /*#__PURE__*/_jsx(MainText, {
      as: "p",
      m: "0",
      fontFamily: "Roboto-medium",
      children: title
    });
  };
  var targetValues = metadata.targetMeasurements && sort(prop("Value"), metadata.targetMeasurements, true).map(function (target, index) {
    var description = cleanHtml(target.Description, []).split("\n").map(function (x, idx) {
      return /*#__PURE__*/_jsx(MainText, {
        m: "5px 0",
        children: x
      }, idx);
    });
    return /*#__PURE__*/_jsxs(TargetContainer, {
      children: [/*#__PURE__*/_jsxs(TargetValue, {
        idx: index,
        children: [target.Value, valueExtension]
      }), /*#__PURE__*/_jsxs(TextContainer, {
        children: [header(target.TargetName), description]
      })]
    }, index);
  });
  var sources = /*#__PURE__*/_jsxs(TextContainer, {
    mt: "20px",
    children: [header("Datakälla"), /*#__PURE__*/_jsx(MainText, {
      m: "5px 0",
      children: (_metadata$information = metadata.informationSource) === null || _metadata$information === void 0 ? void 0 : _metadata$information.name
    })]
  });
  var keywords = /*#__PURE__*/_jsxs(TextContainer, {
    children: [header("Nyckelord"), /*#__PURE__*/_jsx(MainText, {
      m: "5px 0",
      children: metadata.keywords
    })]
  });
  return /*#__PURE__*/_jsxs(Div, {
    as: "section",
    maxWidth: "500px",
    children: [targetValues, sources, keywords]
  });
}